/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {
  Image,
  Platform,
  StyleProp,
  Text,
  TextInput,
  TextInputProps,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import {
  MAIL_VALIDATION,
  MESSAGE_VALIDATION,
  PHONE_NUMBER_VALIDATION,
} from '../../../../common/utils/validation';
import {thousandSeparator} from '../../../../data/factory';
import {InputError} from '../../../../data/types/interface/input';
import {formsStyles} from '../formStyles';
import styles from '../styles';

interface Props extends TextInputProps {
  name: string;
  label?: string;
  labelStyle?: TextStyle;
  parentCallback: any;
  defaultValue?: any;
  required?: boolean;
  isNumeric?: boolean;
  requiredField?: boolean;
  type?: string;
  maxLength?: number;
  onfocus?: any;
  onblur?: any;
  isEditable?: boolean;
  messageError?: string;
  isSubmited?: boolean;
  enterKeyPress?: any;
  showError?: any;
  style?: StyleProp<ViewStyle>;
}

export default React.forwardRef<any, Props>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (props, ref): React.ReactElement => {
    const {
      defaultValue,
      label,
      parentCallback,
      required,
      maxLength,
      onfocus,
      type,
      isEditable,
      messageError,
      isSubmited,
      showError,
    } = props;
    const {requiredField} = props;
    const [value, onChangeText] = useState(defaultValue);
    const [isBlur] = useState(false);
    const [, setUpdateRender] = useState(false);
    const [requiredFields, setRequiredFields] = useState(requiredField);
    const [valueInString, setValueInString] = useState(defaultValue);
    const [displayError, setDisplayError] = useState(
      showError ? showError : false,
    );

    let msg = 'Ce champ est obligatoire';
    if (required) {
      msg = '';
    }
    const [error, setError] = useState<InputError>({
      message: msg,
      exist: value === '',
    });

    if (
      required &&
      typeof isSubmited !== 'undefined' &&
      value === '' &&
      error.exist
    ) {
      if (isBlur) {
        setRequiredFields(true);
      }
    }

    useFocusEffect(() => {
      onChangeText(defaultValue);
      if (type == 'numeric') {
        const cleaned = defaultValue
          ?.toString()
          .replace(/[^0-9]/g, '')
          .toString();
        setValueInString(() => thousandSeparator(cleaned, ' '));
      } else {
        setValueInString(() => value);
      }
    });

    useEffect(() => {
      let exist = true;

      let message = MESSAGE_VALIDATION.requiredField;
      if (isSubmited && isSubmited) {
        if (type === 'email' && value !== '') {
          exist = true;
          message = MESSAGE_VALIDATION.requiredEmail;
        } else {
          exist = value === '';
        }
      } else {
        exist = value !== '';
      }
      if (!required) {
        message = '';
      }

      setError({
        message,
        exist,
      });
    }, [isSubmited]);

    useEffect(() => {
      setDisplayError(showError);
    }, [showError]);

    useEffect(() => {
      setRequiredFields(requiredField);
    }, [requiredField]);

    const [isPasswordShown, setIsPasswordShown] = useState<boolean>(false);

    const [, setIsFocus] = useState(requiredField);
    const handleKeyPress = (e: any) => {
      if (e.keyCode === 13) {
        // Do something
        // enterKeyPress && enterKeyPress();
      }
    };
    const detectBlur = () => {};

    const handleTextChange = (text: string) => {
      // setIsBlur(true);

      if (showError && showError) {
        setDisplayError(false);
      }

      setIsFocus(true);

      setRequiredFields(true);
      let data = text;
      let res = text;
      if (type && type === 'numeric') {
        data = text.replace(/[^0-9]/g, '').toString();
        res = thousandSeparator(data, ' ');
      } else if (
        (type && type === 'telephone') ||
        (type && type === 'telephoneProfil')
      ) {
        res = text.replace(/[^0-9]/g, '').toString();
      } else if (type && type === 'password' && text.length < 6) {
        error.exist = true;
        error.message = MESSAGE_VALIDATION.requiredPassword;
        setError(error);
      } else {
        data = text;
      }
      onChangeText(res);
      if (data === '') {
        error.exist = true;
        if (required) {
          error.message = MESSAGE_VALIDATION.requiredField;
        } else {
          error.message = '';
        }
        setRequiredFields(true);
        setError(error);
        setUpdateRender(true);
      } else if (
        data !== '' &&
        type &&
        (type === 'telephone' || type === 'telephoneProfil')
      ) {
        error.exist = !PHONE_NUMBER_VALIDATION.test(text);
        error.message = MESSAGE_VALIDATION.requiredTelephone;
        setUpdateRender(true);
      } else if (data !== '' && type && type === 'email') {
        if (MAIL_VALIDATION.test(data)) {
          error.exist = false;
          error.message = '';
        } else {
          error.exist = true;
          error.message = MESSAGE_VALIDATION.requiredEmail;
          setError(error);
          setUpdateRender(true);
        }
      } else {
        error.exist = false;
        error.message = '';
        setError(error);
      }

      parentCallback(data, value);
    };

    return (
      <View style={[styles.container]}>
        {label && (
          <Text style={[formsStyles.labelStyle]}>
            {label} {required && <Text>*</Text>} :
          </Text>
        )}
        {isEditable ? (
          type &&
          type === 'inputEditable' && (
            <TextInput
              onKeyPress={handleKeyPress}
              style={[formsStyles.profilFormInput]}
              editable={isEditable}
              maxLength={maxLength}
              keyboardType={'default'}
              onChangeText={text => {
                handleTextChange(text);
              }}
              value={valueInString ? valueInString : value}
              onFocus={onfocus}
              onBlur={detectBlur}
            />
          )
        ) : (
          <Text
            style={{
              fontWeight: 'bold',
              backgroundColor: 'rgba(240, 244, 248, 0.87)',
              padding: 18,
              borderRadius: 100,
              width: Platform.OS === 'web' ? 300 : '100%',
            }}>
            {value || defaultValue}
          </Text>
        )}

        {type &&
          type !== 'inputEditable' &&
          type !== 'textArea' &&
          type !== 'email' &&
          type !== 'telephone' &&
          type !== 'password' && (
            <TextInput
              onKeyPress={handleKeyPress}
              style={[
                type === 'telephoneProfil'
                  ? formsStyles.profilFormInput
                  : formsStyles.itemInputStyle,
                ((required && requiredFields && error.exist) || displayError) &&
                  formsStyles.inputError,
                {
                  backgroundColor:
                    typeof isEditable === 'undefined'
                      ? '#ffffff'
                      : 'rgba(240, 244, 248, 0.87)',
                },
              ]}
              maxLength={maxLength}
              editable={isEditable && isEditable}
              keyboardType={
                type === 'numeric' ||
                type === 'telephone' ||
                type === 'telephoneProfil'
                  ? 'numeric'
                  : 'default'
              }
              secureTextEntry={type === 'password'}
              onChangeText={text => {
                handleTextChange(text);
              }}
              value={(valueInString && valueInString) || value}
              onFocus={onfocus}
              defaultValue={defaultValue}
              onBlur={detectBlur}
            />
          )}

        {type && type === 'textArea' && (
          <TextInput
            onKeyPress={handleKeyPress}
            style={[
              formsStyles.itemInputStyleTextArea,
              ((required && requiredFields && error.exist) || displayError) &&
                formsStyles.inputError,
            ]}
            textAlign="left"
            textAlignVertical="top"
            editable={isEditable && isEditable}
            multiline={true}
            maxLength={maxLength}
            onChangeText={text => {
              handleTextChange(text);
            }}
            value={value}
            onFocus={onfocus}
            onBlur={detectBlur}
          />
        )}
        {type && type === 'email' && (
          <TextInput
            onKeyPress={handleKeyPress}
            style={[
              formsStyles.itemInputStyle,
              ((required && requiredFields && error.exist) || displayError) &&
                formsStyles.inputError,
            ]}
            maxLength={maxLength}
            keyboardType={'default'}
            onChangeText={text => {
              handleTextChange(text);
            }}
            value={value}
            editable={isEditable && isEditable}
            onFocus={onfocus}
            onBlur={detectBlur}
          />
        )}
        {type && type == 'telephone' && (
          <TextInput
            onKeyPress={handleKeyPress}
            style={[
              formsStyles.itemInputStyle,
              ((required && requiredFields && error.exist) || displayError) &&
                formsStyles.inputError,
            ]}
            maxLength={maxLength}
            keyboardType={'numeric'}
            onChangeText={text => {
              handleTextChange(text);
            }}
            value={value}
            editable={isEditable && isEditable}
            onFocus={onfocus}
            onBlur={detectBlur}
          />
        )}
        {!type && type !== 'password' && (
          <TextInput
            onKeyPress={handleKeyPress}
            style={[
              formsStyles.itemInputStyle,
              ((required && requiredFields && error.exist) || displayError) &&
                formsStyles.inputError,
            ]}
            maxLength={maxLength}
            secureTextEntry={type === 'password'}
            keyboardType={
              type === 'numeric' || type === 'telephone' ? 'numeric' : 'default'
            }
            onChangeText={text => {
              handleTextChange(text);
            }}
            value={value}
            editable={isEditable && isEditable}
            onFocus={onfocus}
            onBlur={detectBlur}
          />
        )}

        {type && type === 'password' && (
          <View
            style={[
              formsStyles.itemInputStyle,
              ((required && requiredField && error.exist) || displayError) &&
                formsStyles.inputError,
            ]}>
            {
              <TextInput
                onKeyPress={handleKeyPress}
                style={{flex: 1}}
                maxLength={maxLength}
                secureTextEntry={!isPasswordShown}
                onChangeText={text => {
                  handleTextChange(text);
                }}
                value={value}
                onFocus={onfocus}
                onBlur={detectBlur}
              />
            }

            {
              <TouchableOpacity
                onPress={() => {
                  setIsPasswordShown(!isPasswordShown);
                }}>
                <View
                  style={{
                    width: 60,
                    height: 50,
                  }}>
                  {isPasswordShown && (
                    <Image
                      style={[formsStyles.iconEye]}
                      // eslint-disable-next-line @typescript-eslint/no-require-imports
                      source={require('../../../../ressources/images/Show.png')}
                    />
                  )}
                  {!isPasswordShown && (
                    <Image
                      style={[formsStyles.iconEye]}
                      // eslint-disable-next-line @typescript-eslint/no-require-imports
                      source={require('../../../../ressources/images/Shownot.png')}
                    />
                  )}
                </View>
              </TouchableOpacity>
            }
          </View>
        )}
        {requiredFields && error.exist && (
          <Text style={styles.textError}>{error.message}</Text>
        )}

        {messageError && messageError.length > 0 && (
          <Text style={styles.textError}>{messageError}</Text>
        )}
        {type &&
          type == 'telephoneProfil ' &&
          error.exist &&
          error.message.includes('Veuillez') && (
            <Text style={styles.textError}>{error.message}</Text>
          )}
      </View>
    );
  },
);
